module.exports = __webpack_public_path__ + "img/Arrrr.81cbcd69.jpg";